import { getPromiseWithResolvers } from "./getPromiseWithResolvers";

export async function delay(timeoutMs = 250) {
    const { promise, resolve } = getPromiseWithResolvers();
    setTimeout(resolve, timeoutMs);
    await promise;
}